import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DataContext } from "../../context/DataContext";
import AdminLogin from "./AdminLogin";
import AdminShell from "./AdminShell";

export default function AdminRoutes() {
  const { adminData } = useContext(DataContext);
  const isAdmin = !!adminData?.admin_info?.admin_id;

  return (
    <Routes>
      <Route path="/console" element={isAdmin ? <Navigate to="/console/home" replace /> : <AdminLogin />} />
      <Route path="/console/*" element={isAdmin ? <AdminShell /> : <Navigate to="/console" replace />} />
    </Routes>
  );
}
